import { z } from "zod";

export const shelvingUnitSchema = z.object({
  id: z.number(),
  identifier: z.string(),
  label: z.string(),
  path: z.object({
    identifier: z.string(),
    warehouse: z.object({
      id: z.number(),
      name: z.string(),
      status: z.boolean(),
    }),
  }),
});

export const shelvingUnitFormSchema = z.object({
  id: z.number(),
  identifier: z
    .string()
    .regex(/^[a-zA-Z]+$/, "crud.shelving_unit.validate.string"),
  path_id: z.string(),
  path: z.object({
    warehouse_id: z.string(),
  }),
  positionStickers: z.object({
    pdfUrl: z.string(),
  }),
});
